import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import downArrow from '../../../assets/images/down_arrow.svg';
import downArrowBlue from '../../../assets/images/down_arrow_blue.svg';
import Loading from '../../common/Loading';
import ServiceModal from './ServiceModal';
import DeleteModal from './DeleteModal';
import utils from '../../../lib/utils';

import { Prompt } from 'react-router-dom';

import sample_data from './sample.json';
import editIcon from '../../../assets/images/edit.svg';
import deleteIcon from '../../../assets/images/delete.svg';

import './index.scss';

const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];

const sortDataBy = (data, byKey, order) => {
  let sortedData;
  if (byKey == 'name') {
    sortedData = data.sort(function(a, b) {
      let x = a.name.toLowerCase();
      let y = b.name.toLowerCase();
      if (x > y) {
        return 1 * order;
      }
      if (x < y) {
        return -1 * order;
      }
      return 0;
    });
  } else if (byKey == 'duration') {
    sortedData = data.sort((a, b) => {
      let x = moment.duration(a.duration).format('mm');
      let y = moment.duration(b.duration).format('mm');
      console.log('XY', x, y);
      if (x > y) {
        return 1 * order;
      }
      if (x < y) {
        return -1 * order;
      }
      return 0;
    });
  } else if (byKey == 'serviceType') {
    sortedData = data.sort(function(a, b) {
      let x = (a.serviceTypeLabel || '').toLowerCase();
      let y = (b.serviceTypeLabel || '').toLowerCase();
      if (x > y) {
        return 1 * order;
      }
      if (x < y) {
        return -1 * order;
      }
      return 0;
    });
  } else {
    sortedData = data;
  }
  return sortedData;
};
const filterService = (services) => {
  return services
    ? services.filter((service) => service.kind === 'SESSION')
    : [];
};
export default class DentalSchedulePreview extends React.Component {
  constructor() {
    super();
    this.state = {
      addServiceModalOpen: false,
      deleteServiceModalOpen: false,
      selectedService: {},
      modalServiceType: 'SYNC_SERVICE',
      currentpage: 1,
      totalPage: 1,
      countPerPage: 10,
      serviceCount: 1,
      showPopup: false,
      showDeletePopup: false,
      showDeleteFailPopup: false,
      sortField: 'name',
      sortOrder: 1,
      name: '',
      selectedDuration: 'PT5M',
      selectedProcedureCodes: [],
      serviceMappings: {}
    };
  }

  componentDidMount() {
    const { auth, business } = this.props;
    const { studio_id } = auth;
    const { countPerPage } = this.state;
    const bzid = this.props.business.id || studio_id;
    if (bzid) {
      this.props.getBusinessDetails(bzid);
      this.props.getServiceTypeDetails(bzid);
    }
    if (
      business?.businessDetailsFetched &&
      !utils.isEmptyObject(business?.details)
    ) {
      this.props.storeService(business.details?.services);
      const data = {
        location_id: business?.details?.locations[0]?.id,
        business_id: business.id,
      };
      if (!(auth.booking_software == 'DENTICON' || auth.booking_software == 'CLOUD9' || auth.booking_software == 'OPEN_DENTAL')) {
        this.props.getProcedureCodes(data);
      }
      const serviceLength = filterService(business?.details?.services).length;
      this.setState({
        serviceCount: serviceLength,
        totalPage: Math.ceil(serviceLength / countPerPage),
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { auth, business, schedules } = nextProps;
    const { studio_id } = auth;
    const isCSLogin = csroles.includes(auth?.role);
    const { countPerPage, currentpage } = this.state;
    const bzid = this.props.business.id || studio_id;
    const nextBusinessId = nextProps.business.id || studio_id;
    const serviceCount = filterService(business?.details?.services).length;
    const currentServiceCount = filterService(schedules?.servicetypes).filter(
      (service) =>
        isCSLogin ||
        this.getServiceResolvedBlockType(service, nextProps) !== 'DUMMY_BLOCKED',
    ).length;
    if (
      !utils.isEmptyObject(nextProps?.business?.details) &&
      nextProps?.business?.details !== this.props?.business?.details
    ) {
      this.props.storeService(business.details?.services);
      const data = {
        location_id: business?.details?.locations[0]?.id,
        business_id: business.id,
      };
      if (!(auth.booking_software == 'DENTICON' || auth.booking_software == 'CLOUD9' || auth.booking_software == 'OPEN_DENTAL')) {
        this.props.getProcedureCodes(data);
      }
      this.setState({
        serviceCount: serviceCount,
        serviceMappings: business.details?.data?.dental_preference?.scheduling.service_mapping,
        totalPage: Math.ceil(serviceCount / countPerPage),
      });
    }
    if (nextBusinessId && nextBusinessId !== bzid) {
      this.props.getServiceTypeDetails(nextBusinessId);
    }
    if (
      schedules.addServiceType !== this.props.schedules.addServiceType &&
      schedules.addServiceSuccess
    ) {
      this.setState({
        addServiceModalOpen: false,
        serviceCount: currentServiceCount,
        totalPage: Math.ceil(currentServiceCount / countPerPage),
        name: '',
        selectedDuration: 'PT5M',
        selectedProcedureCodes: [],
      });
      if (nextBusinessId) {
        this.props.getServiceTypeDetails(nextBusinessId);
      }
      this.upDatePopup();
    }
    if (
      schedules.editServiceType !== this.props.schedules.editServiceType &&
      schedules.editServiceSuccess
    ) {
      this.setState({
        addServiceModalOpen: false,
        name: '',
        selectedDuration: 'PT5M',
        selectedProcedureCodes: [],
      });
      if (nextBusinessId) {
        this.props.getServiceTypeDetails(nextBusinessId);
      }
      this.upDatePopup();
    }
    if (
      schedules.deleteServiceType !== this.props.schedules.deleteServiceType &&
      schedules.deleteServiceType === false
    ) {
      this.closeDeleteModal();
      if (schedules.deleteServiceSuccess) {
        console.log('servicetypes', schedules?.servicetypes);
        this.deletePopup();
        this.setState({
          serviceCount: currentServiceCount,
          totalPage: Math.ceil(currentServiceCount / countPerPage),
          currentpage:
            currentpage > Math.ceil(currentServiceCount / countPerPage)
              ? currentpage - 1
              : currentpage,
        });
      } else {
        this.deleteFailurePopup();
      }
    }
    //business.details.data.dental_preference.scheduling.service_mapping;
    // if(this.props.)
    // if(schedules.syncBusiness!==this.props.schedules.syncBusiness && schedules.syncSuccess){
    //     this.props.getBusinessDetails(bzid);
    // }
  }
  upDatePopup = () => {
    this.setState({
      showPopup: true,
    });
    setTimeout(() => {
      this.setState({
        showPopup: false,
      });
    }, 3000);
  };

  deletePopup = () => {
    this.setState({
      showDeletePopup: true,
    });
    setTimeout(() => {
      this.setState({
        showDeletePopup: false,
      });
    }, 3000);
  };
  deleteFailurePopup = () => {
    this.setState({
      showDeleteFailPopup: true,
    });

    setTimeout(() => {
      this.setState({
        showDeleteFailPopup: false,
      });
      this.props.clearServiceFlags();
    }, 3000);
  };
  openServiceModal = (modalServiceType = 'SYNC_SERVICE') => {
    this.setState({
      addServiceModalOpen: true,
      modalServiceType,
    });
  };
  editService = (service) => {
    this.setState({
      addServiceModalOpen: true,
      selectedService: service,
    });
  };

  closeServiceModal = () => {
    this.setState({
      addServiceModalOpen: false,
      selectedService: {},
      modalServiceType: 'SYNC_SERVICE',
    });
    this.props.clearServiceFlags();
  };

  closeDeleteModal = () => {
    this.setState({
      deleteServiceModalOpen: false,
      selectedService: {},
    });
  };

  deleteService = (service) => {
    this.setState({
      deleteServiceModalOpen: true,
      selectedService: service,
    });
  };

  deleteServiceType = (service) => {
    const { business, auth } = this.props;
    const serviceFriendlyDetails = this.getServiceTypeFriendlyDetails(service.id);
    const data = {
      location_id: business?.details?.locations[0]?.id,
      business_id: business.id || auth.studio_id,
      service_id: service.id,
      block_type: serviceFriendlyDetails?.block_type,
      updated_by: business?.clientUser?.email,
    };
    this.props.deleteServiceTypes(data);
  };
  getProcedureCode = (proc_id) => {
    const { schedules } = this.props;
    const procedures = schedules.procedure_codes.filter(
      (procedure) => procedure.id == proc_id,
    );
    return procedures.length > 0 ? procedures[0].code : proc_id;
  };
  getPages = () => {
    const { totalPage } = this.state;
    let pages = [];
    for (let i = 0; i < totalPage; i++) {
      pages.push(i + 1);
    }
    return pages;
  };
  changePage = (page) => {
    this.setState({
      currentpage: page,
    });
  };
  nextPage = () => {
    const { currentpage, totalPage } = this.state;
    if (currentpage < totalPage) {
      this.setState({
        currentpage: currentpage + 1,
      });
    }
  };
  prevPage = () => {
    const { currentpage } = this.state;
    if (currentpage > 1) {
      this.setState({
        currentpage: currentpage - 1,
      });
    }
  };
  updateServiceMapping = (serviceMappings) => {
    this.setState({
         serviceMappings
    });
  }

  getServiceTypeFriendlyDetails = (serviceId, props = this.props) => {
    const { schedules } = props;
    const details = schedules?.serviceTypeDetails || [];
    const normalizedServiceId = String(serviceId || '');
    return (
      details.find(
        (serviceDetail) => {
          const detailServiceId = String(serviceDetail?.service_id || '');
          const detailId = String(serviceDetail?.id || '');
          const detailServiceTypeId = String(
            serviceDetail?.service_type_id || '',
          );
          return (
            detailServiceId === normalizedServiceId ||
            detailId === normalizedServiceId ||
            detailServiceTypeId === normalizedServiceId
          );
        },
      ) || {}
    );
  };

  getServiceResolvedBlockType = (service, props = this.props) => {
    const serviceFriendlyDetails = this.getServiceTypeFriendlyDetails(
      service.id,
      props,
    );
    return serviceFriendlyDetails?.block_type || service?.block_type || 'NONE';
  };

  getDisplayServicesList = () => {
    const { sortField, sortOrder, serviceMappings } = this.state;
    const { schedules, auth } = this.props;
    const isCSLogin = csroles.includes(auth?.role);

    let services = filterService(schedules?.servicetypes)?.length > 0
      ? filterService(schedules?.servicetypes)
      : [];

    let selectedProcedureIdsForDA = [];
    if (serviceMappings && Object.keys(serviceMappings).length > 0) {
      console.log('inside serviceMapping');
      services.forEach((s) => {
        selectedProcedureIdsForDA = serviceMappings[s.id];
        console.log('selectedProcedureIdsForDA = ', selectedProcedureIdsForDA);
        if (selectedProcedureIdsForDA) {
          selectedProcedureIdsForDA = selectedProcedureIdsForDA.map((serviceId) => Number(serviceId));
          const selectedProcedureCodesForDA = schedules.procedure_codes.filter((procedure) => selectedProcedureIdsForDA.includes(procedure.id));
          s.steps = selectedProcedureCodesForDA;
        }
      });
    }

    services = services
      .map((service) => {
        const resolvedBlockType = this.getServiceResolvedBlockType(service);
        const isBlockedService =
          resolvedBlockType === 'DUMMY_BLOCKED' ||
          resolvedBlockType === 'SYNCED_BLOCKED';
        const serviceTypeLabel =
          resolvedBlockType === 'DUMMY_BLOCKED'
            ? 'ESCALATION'
            : 'PMS';
        return {
          ...service,
          serviceTypeLabel,
          isBlockedService,
          resolvedBlockType,
        };
      })
      .filter((service) => isCSLogin || service.resolvedBlockType !== 'DUMMY_BLOCKED');

    return sortDataBy(services, sortField, sortOrder);
  };

  getServices = () => {
    const { currentpage, countPerPage } = this.state;
    const services = this.getDisplayServicesList();
    const start = (currentpage - 1) * countPerPage;
    const end =
      currentpage * countPerPage > services.length
        ? services.length
        : currentpage * countPerPage;
    console.log('services', services);
    return services.slice(start, end);
  };
  sortType = (field, order) => {
    this.setState({
      sortField: field,
      sortOrder: order,
    });
  };
  handleChangeInForm = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  saveButtonHandling = () => {
  const { auth, business } = this.props;
  const { serviceMappings } = this.state;
  const { studio_id } = auth;
  const bzid = business.id || studio_id;

  if(auth.booking_software === 'DENTRIX_ASCEND'){
    this.props.updateServiceMappingsAPI(auth.userid, serviceMappings)
  }else{
    this.props.syncServiceTypes(bzid);
  }
  };

  render() {
    const { softwares, business, schedules, auth } = this.props;
    const {
      service_dropdwon,
      addServiceModalOpen,
      deleteServiceModalOpen,
      selectedService,
      currentpage,
      countPerPage,
      totalPage,
      showPopup,
      sortOrder,
      sortField,
      showDeletePopup,
      showDeleteFailPopup,
      serviceMappings
    } = this.state;
    const { studio_id } = auth;
    const isCSLogin = csroles.includes(auth?.role);
    const { business_metadata } = business?.details;
    const bzid = business.id || studio_id;
    const serviceLength = this.getDisplayServicesList().length;
    const pmsList =
      business?.details?.locations?.length > 0
        ? business.details?.locations[0].location_metadata?.associated_pms
        : null;
    console.log('business_metadata', business_metadata);
    const errorMessage = schedules.errorMessage || 'Something went wrong';
    return (
      <div className="schedule">
        <Prompt
          when={schedules.updateBusinessData}
          message={
            'There are unsaved changes, are you sure you want to leave without saving?'
          }
        />

        {(softwares.studioId !== '' || bzid !== '') ? (
          <>
            <div className="schedule_title">
              <div className="schedule_title_content">
                <div className="title">Service Types</div>
                {!(auth.booking_software == 'DENTICON' || auth.booking_software == 'CLOUD9' || auth.booking_software == 'DENTRIX_ASCEND' || auth.booking_software == 'OPEN_DENTAL')  && (
                 <>
                    <div className="add-service-actions">
                      <button
                        className={classnames('add-service', {
                          disabled:
                            business_metadata?.is_appointment_types_read_only ===
                            'true',
                        })}
                        onClick={() => this.openServiceModal('SYNC_SERVICE')}
                        disabled={
                          business_metadata?.is_appointment_types_read_only === 'true'
                        }
                      >
                        + Add service type
                      </button>
                      {isCSLogin && (
                        <button
                          className={classnames('add-service', {
                            disabled:
                              business_metadata?.is_appointment_types_read_only ===
                              'true',
                          })}
                          onClick={() => this.openServiceModal('DUMMY_SERVICE')}
                          disabled={
                            business_metadata?.is_appointment_types_read_only === 'true'
                          }
                        >
                          + Add escalation
                        </button>
                      )}
                    </div>
                 </>
                 )}
              </div>
              <div className="serviceschedule_title_pms">
                <div>{pmsList}</div>{' '}
                {!(auth.booking_software == 'DENTICON' || auth.booking_software == 'CLOUD9' || auth.booking_software == 'DENTRIX_ASCEND' || auth.booking_software == 'OPEN_DENTAL') && (
                 <>
                    <div className="serviceschedule_title_pms_synctime">
                      Last updated:{' '}
                      {moment(business?.details?.last_sync_time).fromNow()}
                    </div>
                 </>
                 )}
              </div>

              {business.getBusinessDetails || schedules.getServiceTypeDetails || (!(auth.booking_software == 'DENTICON' || auth.booking_software == 'CLOUD9') && schedules.getProcedureCodes) ? (
                <div className="schedule_title_table">
                  <div className="schedule_loader">
                    <Loading />
                  </div>
                </div>
              ) : (
                <div className="schedule_title_table">
                  <div className="schedule_title_table_header">
                    <div className="row name">
                      NAME{' '}
                      <img
                        className={classnames('arrow', {
                          'rotate-arrow':
                            sortOrder === -1 && sortField === 'name',
                        })}
                        src={sortField !== 'name' ? downArrow : downArrowBlue}
                        onClick={() => this.sortType('name', sortOrder * -1)}
                      />{' '}
                    </div>
                    <div className="row duration">
                      DURATION{' '}
                      <img
                        className={classnames('arrow', {
                          'rotate-arrow':
                            sortOrder === -1 && sortField === 'duration',
                        })}
                        src={
                          sortField !== 'duration' ? downArrow : downArrowBlue
                        }
                        onClick={() =>
                          this.sortType('duration', sortOrder * -1)
                        }
                      />{' '}
                    </div>
                    {isCSLogin && (
                      <>
                        <div className="row service-type">
                          SERVICE TYPE{' '}
                          <img
                            className={classnames('arrow', {
                              'rotate-arrow':
                                sortOrder === -1 && sortField === 'serviceType',
                            })}
                            src={
                              sortField !== 'serviceType' ? downArrow : downArrowBlue
                            }
                            onClick={() =>
                              this.sortType('serviceType', sortOrder * -1)
                            }
                          />{' '}
                        </div>
                        <div className="row friendly-name">FRIENDLY NAME</div>
                        <div className="row friendly-description">DESCRIPTION</div>
                      </>
                    )}
                    {/* <div className="row bookable">Bookable via TrueLark <img className="arrow" src={downArrow} /></div> */}
                    <div className="actions"></div>
                  </div>
                  {serviceLength < 1 ? (
                    <div className="schedule_title_table_body">
                      <div className="no-service-types">
                        {' '}
                        No service types. Add one to get started.
                      </div>
                    </div>
                  ) : (
                    <div className="schedule_title_table_body">
                      {this.getServices().map((data) => {
                        const serviceFriendlyDetails = this.getServiceTypeFriendlyDetails(
                          data.id,
                        );
                        const friendlyName =
                          serviceFriendlyDetails?.friendly_name ||
                          data?.friendly_name ||
                          '--';
                        const friendlyDescription =
                          serviceFriendlyDetails?.friendly_description ||
                          data?.friendly_description ||
                          '--';
                        return (
                          <div
                            className={classnames('servie-type-container', {
                              'blocked-service': isCSLogin && data.isBlockedService,
                            })}
                          >
                            <div className="servie-type-container_name">
                              <div>{data.name}</div>
                              <div className="procedure_codes">
                                {data?.steps?.map((step, index) => {
                                  return (
                                    <span>
                                      {this.getProcedureCode(step.id)}
                                      {index !== data?.steps?.length - 1
                                        ? ', '
                                        : null}
                                    </span>
                                  );
                                })}{' '}
                              </div>
                            </div>
                            <div className="servie-type-container_duration">
                              {moment.duration(data.duration).format('mm')} min
                            </div>
                            {isCSLogin && (
                              <>
                                <div className="servie-type-container_service-type">
                                  {data.serviceTypeLabel}
                                </div>
                                <div className="servie-type-container_friendly-name">
                                  {friendlyName}
                                </div>
                                <div className="servie-type-container_friendly-description">
                                  {friendlyDescription}
                                </div>
                              </>
                            )}
                            {/* <div className={classnames('servie-type-container_bookable',{'true':data.bookable}) }>{data.bookable?'Yes':'No'}</div> */}
                            <div className="servie-type-container_actions">
                              {(auth.booking_software == 'DENTRIX_ASCEND') ?
                                  ( <img src={editIcon} onClick={() => this.editService(data)}/>) :
                                  (business_metadata?.is_appointment_types_read_only === 'false' &&  (
                                   <>
                                      <img
                                        src={editIcon}
                                        onClick={() => this.editService(data)}
                                      />
                                      <img
                                        src={deleteIcon}
                                        onClick={() => this.deleteService(data)}
                                      />{' '}
                                   </>)
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {serviceLength > 0 && (
                    <>
                      <div className="schedule_title_table_pagination">
                        <div className="count">
                          Showing {(currentpage - 1) * countPerPage + 1}-
                          {currentpage * countPerPage > serviceLength
                            ? serviceLength
                            : currentpage * countPerPage}{' '}
                          of {serviceLength} entries
                        </div>
                        <div className="paging">
                          {currentpage !== 1 && (
                            <span
                              className={classnames('page-number')}
                              onClick={() => this.prevPage()}
                            >
                              PREV
                            </span>
                          )}
                          {this.getPages().map((page) => (
                            <span
                              className={classnames('page-number', {
                                active: page === currentpage,
                              })}
                              onClick={() => this.changePage(page)}
                            >
                              {page}
                            </span>
                          ))}
                          {totalPage !== currentpage && (
                            <span
                              className={classnames('page-number')}
                              onClick={() => this.nextPage()}
                            >
                              NEXT
                            </span>
                          )}
                        </div>
                      </div>
                      {!(auth.booking_software == 'DENTICON' || auth.booking_software == 'CLOUD9') && (
                        <>
                          <div className="schedule_title_table_save">
                            <button
                              className="btn btn--primary btn--lg"
                              onClick={this.saveButtonHandling}
                              disabled={schedules.syncBusiness}
                            >
                              {schedules.syncBusiness ? 'SAVING..' : 'SAVE'}
                            </button>
                          </div>
                       </>
                       )}
                    </>
                  )}
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="non-authenticated">
            Complete practice management software authorization under{' '}
            <a className="setup-link" href="/#/app/setup/summary">
              AI Setup &gt; Setup
            </a>
            , to start defining your schedule.
          </div>
        )}
        {showPopup && (
          <div className="copy-webhook">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            Update was successful. Please save the changes for it to reflect.
          </div>
        )}
        {showDeletePopup && (
          <div className="copy-webhook">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            Delete was successful. Please save the changes for it to reflect.
          </div>
        )}
        {showDeleteFailPopup && (
          <div className="copy-webhook-failure">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            {errorMessage}
          </div>
        )}
        {addServiceModalOpen && (
          <ServiceModal
            selectedService={selectedService}
            selectedServiceDetails={this.getServiceTypeFriendlyDetails(
              selectedService?.id,
            )}
            modelopen={addServiceModalOpen}
            closeServiceModal={this.closeServiceModal}
            schedules={schedules}
            addServiceTypes={this.props.addServiceTypes}
            editServiceTypes={this.props.editServiceTypes}
            business={business}
            handleChangeInForm={this.handleChangeInForm}
            name={this.state.name}
            selectedDuration={this.state.selectedDuration}
            selectedProcedureCodes={this.state.selectedProcedureCodes}
            selectedType={this.state.modalServiceType}
            blockType={
              this.state.modalServiceType === 'DUMMY_SERVICE'
                ? 'DUMMY_BLOCKED'
                : 'NONE'
            }
            serviceMappings={this.state.serviceMappings}
            updateServiceMapping={this.updateServiceMapping}
            auth={this.props.auth}
            isCSLogin={isCSLogin}
          />
        )}
        {deleteServiceModalOpen && (
          <DeleteModal
            selectedService={selectedService}
            modelopen={deleteServiceModalOpen}
            closeServiceModal={this.closeDeleteModal}
            deleteServiceType={this.deleteServiceType}
            schedules={schedules}
            business={business}
          />
        )}
      </div>
    );
  }
}
